'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.service:googleTokenPersistance
 * @description
 * # googleTokenPersistance
 * Service of the thothAppApp, to persist the google token
 */
angular.module('thothApp.services')
  .factory('googleTokenPersistance', ['$window','domain', function($window, domain) {
    var googleTokenPersistance = {
      response: function(response) {
        if('data' in response && typeof(response.data) === 'object') {
          if('meta' in response.data && 'google_token' in response.data.meta) {
            $window.localStorage.googleToken = response.data.meta.google_token;
            
            var fecha = new Date();
            fecha.setFullYear(fecha.getFullYear() + 1);
            const ApiUser = localStorage.getItem('apiUser');
            const token = localStorage.getItem('thoth_token');
            const googleToken = localStorage.getItem('googleToken');

            var cookieDomain = '';
            if (domain.name.includes('localhost')) {
              cookieDomain = '.localhost';
            } else if (domain.name.includes('scisa.com.mx')) {
              cookieDomain = '.scisa.com.mx';
            }

            document.cookie = "apiUser=" + ApiUser + "; expires=" + fecha.toUTCString() + "; domain=" + cookieDomain;
            document.cookie = "thoth_token=" + token + "; expires=" + fecha.toUTCString() + "; domain=" + cookieDomain;
            document.cookie = "googleToken=" + googleToken + "; expires=" + fecha.toUTCString() + "; domain=" + cookieDomain;

          }
        }
        return response;
      }
    };
    return googleTokenPersistance;
}]);
